import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormPayload } from './types';
import { initialValues } from './contants';
import GeneralSection from './Components/Sections/GeneralSection/GeneralSection';
import { validate } from './Utils/ValidateUtils';
import { Container } from './SignInFormModule.styles';
import { ErrorsSection } from './Components/Sections/ErrorsSection/ErrorsSection';
import { AuthModuleProps } from '../../../Interfaces/Pages';
import { urlManager } from '../../../Utils/URL/URLManager';

import { AdditionalSection } from './Components/Sections/AdditionalSection/AdditionalSection';
import { submitHandle } from './Utils/submitHandleUtils';
import { WIDTH_MODULE } from '../../../Constants/Auth';
import { AuthFormLayout } from '../../../Components/Forms/Auth';

interface Props extends AuthModuleProps {}

export const SignInFormModule: React.FC<Props> = ({ width = WIDTH_MODULE }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const resetErrorsHandle = useCallback(() => {
    setErrors([]);
  }, []);

  const toSignInHandle = useCallback(
    async (values: FormPayload) => {
      await submitHandle({
        values,
        preAction: resetErrorsHandle,
        doAction: () => {
          navigate(urlManager.home());
        },
        errorAction: message => {
          setErrors(prevState => [...prevState, message]);
        },
      });
    },
    [navigate, resetErrorsHandle],
  );

  return (
    <Container width={width}>
      <AuthFormLayout<FormPayload>
        title="Sign In Form"
        validate={validate(initialValues)}
        initialValues={initialValues}
        submitFormHandler={toSignInHandle}
        resetErrorsHandle={resetErrorsHandle}
      >
        <GeneralSection />
        <ErrorsSection errors={errors} />
        <AdditionalSection />
      </AuthFormLayout>
    </Container>
  );
};
